import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Event from '../../../event';
import Video from './Video';
import Img from './Img';
import Iframe from './Iframe';

class Media extends Component {
    static propTypes = {
        index: PropTypes.number,
        url: PropTypes.string,
        type: PropTypes.string,
        width: PropTypes.number,
        height: PropTypes.number,
        playermsg: PropTypes.object,
    };

    constructor(props) {
        super(props);
        this.event = new Event();
        this.mediaRef = React.createRef();
    }

    on(eventName, callback) {
        this.mediaRef.current.on(eventName, callback);
    }

    off(eventName, callback) {
        this.mediaRef.current.off(eventName, callback);
    }

    show() {
        this.mediaRef.current.show();
    }

    hide() {
        this.mediaRef.current.hide();
    }

    play() {
        return this.mediaRef.current.play();
    }

    pause() {
        return this.mediaRef.current.pause();
    }

    setVolume(volume) {
        this.mediaRef.current.setVolume(volume);
    }

    getVolume() {
        return this.mediaRef.current.getVolume();
    }

    setMuted(muted) {
        this.mediaRef.current.setMuted(muted);
    }

    getDom() {
        return this.mediaRef.current.getDom();
    }

    render() {
        const { index, url, type, width, height, duration, playermsg } = this.props;
        const { width: playerWidth, height: playerHeight } = playermsg;
        const content = { index, url, type, width, height, duration, playerWidth, playerHeight };

        switch (type) {
            case 'video':
                return <Video content={content} ref={this.mediaRef} />;
            case 'img':
                return <Img content={content} ref={this.mediaRef} />;
            case 'iframe':
                return <Iframe content={content} ref={this.mediaRef} />;
            default:
                return null;
        }
    }
}

export default Media;
